import Repository from "./Repository";

const GET_FORM = "/ffc_form/getall";
const CREATE_FORM = "/ffc_form/add";
const UPDATE_FORM = "/ffc_form/update";
const DELETE_FORM = "/ffc_form/delete";

const GET_BANNER = "/ffc_banner/getall";
const CREATE_BANNER = "/ffc_banner/create";
const UPDATE_BANNER = "/ffc_banner/update";
const DELETE_BANNER = "/ffc_banner/delete";

const GET_PARTNER = "/ffc_partner/getall";
const CREATE_PARTNER = "/ffc_partner/create";
const UPDATE_PARTNER = "/ffc_partner/update";
const DELETE_PARTNER = "/ffc_partner/delete";

const GET_TESTIMONIAL = "/ffc_testimonial/get";
const GET_ALL_TESTIMONIAL = "/ffc_testimonial/getall";
const CREATE_TESTIMONIAL = "/ffc_testimonial/create";
const UPDATE_TESTIMONIAL = "/ffc_testimonial/update";
const DELETE_TESTIMONIAL = "/ffc_testimonial/delete";

const GET_HUB = "/ffc_hub/getall";
const CREATE_HUB = "/ffc_hub/create";
const UPDATE_HUB = "/ffc_hub/update";
const DELETE_HUB = "/ffc_hub/delete";

const GET_REVIEW = "/ffc_review/getall";
const CREATE_REVIEW = "/ffc_review/create";
const UPDATE_REVIEW = "/ffc_review/update";
const DELETE_REVIEW = "/ffc_review/delete";

const GET_CORPORATE_EVENTS = "/ffc_corporateEvent/get";
const CREATE_CORPORATE_EVENTS = "/ffc_corporateEvent/add";
const UPDATE_CORPORATE_EVENTS = "/ffc_corporateEvent/edit";
const DELETE_CORPORATE_EVENTS = "/ffc_corporateEvent/delete";

const GET_FUTURE_TRENDS = "/ffc_futureTrends/get";
const CREATE_FUTURE_TRENDS = "/ffc_futureTrends/add";
const UPDATE_FUTURE_TRENDS = "/ffc_futureTrends/edit";
const DELETE_FUTURE_TRENDS = "/ffc_futureTrends/delete";

const GET_PODCAST = "/ffc_podcast/get";
const CREATE_PODCAST = "/ffc_podcast/add";
const UPDATE_PODCAST = "/ffc_podcast/edit";
const DELETE_PODCAST = "/ffc_podcast/delete";

const GET_EVENTREG = "/ffc_eventRegistration/get";
const CREATE_EVENTREG = "/ffc_eventRegistration/add";
const UPDATE_EVENTREG = "/ffc_eventRegistration/edit";
const DELETE_EVENTREG = "/ffc_eventRegistration/delete";

export default {
  get_form(payload) {
    return Repository.get(transformRoute(GET_FORM), {
      params: payload,
    });
  },
  add_form(payload) {
    return Repository.post(transformRoute(CREATE_FORM), payload);
  },
  update_form(payload) {
    return Repository.post(transformRoute(UPDATE_FORM), payload);
  },
  delete_form(payload) {
    return Repository.post(transformRoute(DELETE_FORM), payload);
  },

  //-------//

  get_banner(payload) {
    return Repository.get(transformRoute(GET_BANNER), {
      params: payload,
    });
  },
  add_banner(payload) {
    return Repository.post(transformRoute(CREATE_BANNER), payload);
  },
  update_banner(payload) {
    return Repository.post(transformRoute(UPDATE_BANNER), payload);
  },
  delete_banner(payload) {
    return Repository.post(transformRoute(DELETE_BANNER), payload);
  },

  //-------//

  get_partner(payload) {
    return Repository.get(transformRoute(GET_PARTNER), {
      params: payload,
    });
  },
  add_partner(payload) {
    return Repository.post(transformRoute(CREATE_PARTNER), payload);
  },
  update_partner(payload) {
    return Repository.post(transformRoute(UPDATE_PARTNER), payload);
  },
  delete_partner(payload) {
    return Repository.post(transformRoute(DELETE_PARTNER), payload);
  },

  //-------//

  get_testimonial(payload) {
    return Repository.post(transformRoute(GET_TESTIMONIAL), payload);
  },
  getall_testimonial(payload) {
    return Repository.post(transformRoute(GET_ALL_TESTIMONIAL), payload);
  },
  add_testimonial(payload) {
    return Repository.post(transformRoute(CREATE_TESTIMONIAL), payload);
  },
  update_testimonial(payload) {
    return Repository.post(transformRoute(UPDATE_TESTIMONIAL), payload);
  },
  delete_testimonial(payload) {
    return Repository.post(transformRoute(DELETE_TESTIMONIAL), payload);
  },

  //-------//

  get_hub(payload) {
    return Repository.get(transformRoute(GET_HUB), {
      params: payload,
    });
  },
  add_hub(payload) {
    return Repository.post(transformRoute(CREATE_HUB), payload);
  },
  update_hub(payload) {
    return Repository.post(transformRoute(UPDATE_HUB), payload);
  },
  delete_hub(payload) {
    return Repository.post(transformRoute(DELETE_HUB), payload);
  },

  //-------//

  get_review(payload) {
    return Repository.get(transformRoute(GET_REVIEW), {
      params: payload,
    });
  },
  add_review(payload) {
    return Repository.post(transformRoute(CREATE_REVIEW), payload);
  },
  update_review(payload) {
    return Repository.post(transformRoute(UPDATE_REVIEW), payload);
  },
  delete_review(payload) {
    return Repository.post(transformRoute(DELETE_REVIEW), payload);
  },

  //---Corporate Event----//

  getCorporateEvents(payload) {
    return Repository.post(transformRoute(GET_CORPORATE_EVENTS), {
      params: payload,
    });
  },
  addCorporateEvents(payload) {
    return Repository.post(transformRoute(CREATE_CORPORATE_EVENTS), payload);
  },
  editCorporateEvents(payload) {
    return Repository.post(transformRoute(UPDATE_CORPORATE_EVENTS), payload);
  },
  deleteCorporateEvents(payload) {
    return Repository.post(transformRoute(DELETE_CORPORATE_EVENTS), payload);
  },

  //---Future trends----//

  getFutureTrends(payload) {
    return Repository.post(transformRoute(GET_FUTURE_TRENDS), {
      params: payload,
    });
  },
  addFutureTrends(payload) {
    return Repository.post(transformRoute(CREATE_FUTURE_TRENDS), payload);
  },
  editFutureTrends(payload) {
    return Repository.post(transformRoute(UPDATE_FUTURE_TRENDS), payload);
  },
  deleteFutureTrends(payload) {
    return Repository.post(transformRoute(DELETE_FUTURE_TRENDS), payload);
  },

  //---FFC Podcast----//

  getPodcast(payload) {
    return Repository.post(transformRoute(GET_PODCAST), {
      params: payload,
    });
  },
  addPodcast(payload) {
    return Repository.post(transformRoute(CREATE_PODCAST), payload);
  },
  editPodcast(payload) {
    return Repository.post(transformRoute(UPDATE_PODCAST), payload);
  },
  deletePodcast(payload) {
    return Repository.post(transformRoute(DELETE_PODCAST), payload);
  },
  //---FFC Event reg----//

  getEventReg(payload) {
    return Repository.post(transformRoute(GET_EVENTREG), {
      params: payload,
    });
  },
  addEventReg(payload) {
    return Repository.post(transformRoute(CREATE_EVENTREG), payload);
  },
  editEventReg(payload) {
    return Repository.post(transformRoute(UPDATE_EVENTREG), payload);
  },
  deleteEventReg(payload) {
    return Repository.post(transformRoute(DELETE_EVENTREG), payload);
  },
};

const transformRoute = (route) => {
  return `/ffc${route}`;
};
